import { render, staticRenderFns } from "./ListProdutos.vue?vue&type=template&id=43899014"
import script from "./ListProdutos.vue?vue&type=script&lang=js"
export * from "./ListProdutos.vue?vue&type=script&lang=js"
import style0 from "./ListProdutos.vue?vue&type=style&index=0&id=43899014&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports